<template>
  <div class="info-banner text-blue mt-20">
    <i class="fa fa-info-circle pr-5"></i>
    <span class="info-text">
      Progress will not be saved if you cancel configuration or exit. If you need help, check our
      <a
        href="https://support.hubstaff.com/configuring-single-sign-on/"
        target="_blank"
      >support article</a>
      for specific instructions.
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProgressNotice',
};
</script>
